import * as _ from 'lodash'

import createCachedFetch from '~/util/cachedFetch/createCachedFetch'
import { hasPermission } from '~/modules/services/permission'
import { setWebsites } from '~/redux/websites'

function site(pharosService, $ngRedux) {
  let _websites = {}

  this.siteServiceCache = createCachedFetch()

  let sites = []

  this.logErrorToSentry = (url) => (error) => {
    pharosService.sendExceptionToSentry(error, `Failed to fetch ${url}`)
    throw error
  }

  const setResults = (response) => {
    const filter =
      (window.org_settings && window.org_settings.siteServiceHierarchy) ||
      'default'
    sites = []

    const addSection = (section, indent) => {
      const parentRef = section.parent || {}

      sites.push({
        id: section._id,
        original_name: section.name,
        name: indent + section.name,
        parentId: parentRef[filter] || parentRef.default || parentRef,
        value: section._id,
        content_code: (section.metadata && section.metadata.content_code) || '',
      })

      indent += '&#160;&#160;&#160;&#160;&#160;'

      if (section.children) {
        section.children.forEach((child) => {
          addSection(child, indent)
        })
      }
    }

    if (response && response.children) {
      response.children.forEach((section) => {
        addSection(section, '')
      })
    }

    if (sites.length) {
      sites.unshift({ id: '', name: '', value: '' })
    }

    return sites
  }

  const setSections = (response) => {
    const filter =
      (window.org_settings && window.org_settings.siteServiceHierarchy) ||
      'default'
    const addSection = (currWebsite, section, indent) => {
      const parentRef = section.parent || {}

      _websites[currWebsite].sections.push({
        id: section._id,
        original_name: section.name,
        name: indent + section.name,
        parentId: parentRef[filter] || parentRef.default || parentRef,
        value: section._id,
        content_code: (section.metadata && section.metadata.content_code) || '',
      })

      indent += '&#160;&#160;&#160;&#160;&#160;'

      if (section.children) {
        section.children.forEach((child) => {
          if (child.node_type !== 'link') {
            addSection(currWebsite, child, indent)
          }
        })
      }
    }

    const currWebsite = response._website
    _websites[currWebsite].sections = []

    if (response && response.children) {
      response.children.forEach((section) => {
        addSection(currWebsite, section, '')
      })
    }

    return _websites[currWebsite]
  }

  this.getWebsite = (website) => {
    // App logic imply that getWebsite will be called only after getWebsites call
    // This condition added for the safety and test purposes
    if (!_websites[website]) {
      return Promise.reject(
        new Error(
          `Could not resolve get getWebSite Promise for website ${website}`
        )
      )
    }
    if (_websites[website].sections) {
      return Promise.resolve(_websites[website])
    }
    const hasViewPermission = hasPermission(
      window.userRolesAuth.story.viewStory,
      website
    )
    if (!hasViewPermission) {
      return Promise.reject(
        new Error(
          'Could not resolve get getWebSite Promise due to lack of viewing permissions'
        )
      )
    }
    const filter =
      (window.org_settings && window.org_settings.siteServiceHierarchy) ||
      'default'
    const url = `/siteservice-readonly/api/v3/navigation/${website}?hierarchy=${filter}&fallback_default=true`
    return this.siteServiceCache(url)
      .then(setSections)
      .catch(this.logErrorToSentry(url))
  }

  // get all the sites without a parent
  this.getTopLevelSites = () => {
    const url = `/siteservice-readonly/api/v2/navigation?hierarchy=default&fallback_default=true`
    return this.siteServiceCache(url)
      .then(setResults)
      .then((sites) => sites.filter((s) => s.parentId === '/'))
      .catch(this.logErrorToSentry(url))
  }

  // siteService.getBasePathForSite(this.storyObj.taxonomy.primary_site) <-- basic idea on calling it
  this.getBasePathForSite = (primarySite) => {
    const lookup = sites.reduce((o, i) => {
      o[i.id] = i
      return o
    }, {})

    // walk the tree to get the top level parent id
    let item = lookup[primarySite._id]
    let parentId = primarySite._id
    while (item) {
      parentId = item.id
      item = lookup[item.parentId]
    }

    const basePaths =
      (window.org_settings && window.org_settings.siteServiceBasePaths) || []
    const lookUpHash = basePaths.reduce((o, i) => {
      o[i.id] = i.path
      return o
    }, {})
    return lookUpHash[parentId] || lookUpHash.default || null
  }

  this.getWebsites = () => {
    // We can not just cache websites since `getWebsite` call add sections to the particular web site
    // some other logic might rely on `getWebsites` return websites with sections
    if (Object.keys(_websites).length > 0) {
      return Promise.resolve(_websites)
    }
    const url = `/siteservice-readonly/api/v3/website`
    return this.siteServiceCache(url)
      .then((response) => {
        if (!response || !_.isArray(response)) {
          return {}
        }
        return response.reduce((result, website) => {
          return {
            ...result,
            [website._id]: website,
          }
        }, {})
      })
      .then((websites) => {
        _websites = websites
        $ngRedux.dispatch(setWebsites(websites))
        return websites
      })
      .catch(this.logErrorToSentry(url))
  }
}

export default ['pharosService', '$ngRedux', site]
